// Module
var code = "<span ng-if=$ctrl.dayFirst>{{$ctrl.day}} {{$ctrl.displayMonth}}</span> <span ng-if=!$ctrl.dayFirst>{{$ctrl.displayMonth}} {{$ctrl.day}}</span> ";
// Exports
module.exports = code;